import moment from 'moment';

export function getOffetFromTimeZone(timeZone) {
  if (!timeZone) return null;
  const now = new moment();
  return moment.tz.zone(timeZone).offset(now) / 60;
}
